module.exports = __webpack_public_path__ + "static/media/email.8bf810e2.svg";